import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { AutoSizer } from 'react-virtualized';
import { IDexTrade, ITicker } from '@kattana-io/common';
import useCollectTickers from '../../../../components/DexTrades/useCollectTickers';
import { IStore } from '../../../../reducers';
import MyTradesTable from './Table';
import { switchCurrentTicker } from '../../../../Authlogic';

interface ITradesDataLayerProps {
  chain: string;
  wallet: string;
  trades: IDexTrade[];
  loading: boolean;
  isMobile?: boolean;
  onCancel: () => void;
}

/**
 * Data-layer wrapper
 * @param param0
 * @returns
 */
const MyTradesDataLayer = ({
  chain,
  wallet,
  trades,
  loading,
  onCancel,
}: ITradesDataLayerProps) => {
  const timezone = useSelector((state: IStore) => state.timezone.current);

  const { tickers, loadingTickers } = useCollectTickers(trades);

  const onTickerClick = useCallback(
    (ticker: ITicker) => {
      switchCurrentTicker(ticker);
      onCancel();
    },
    [onCancel]
  );

  return (
    <AutoSizer style={{ width: '100%', height: '100%' }}>
      {({ width }) => (
        <MyTradesTable
          network={chain}
          address={wallet}
          timezone={timezone}
          trades={trades}
          tickers={tickers || loadingTickers}
          loading={loading}
          width={width}
          onTickerClick={onTickerClick}
        />
      )}
    </AutoSizer>
  );
};

export default MyTradesDataLayer;
